
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserCourses } from "@/lib/user-courses";
import { toast } from "@/components/ui/use-toast";

interface UseEnrollmentRedirectOpts {
  user: { id: string } | null | undefined;
  courseId: string | undefined;
  onRedirect?: () => void;
}

export function useEnrollmentRedirect({ user, courseId, onRedirect }: UseEnrollmentRedirectOpts) {
  const [checkingEnrollment, setCheckingEnrollment] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkEnrollment = async () => {
      if (!user || !courseId || checkingEnrollment) return;
      try {
        setCheckingEnrollment(true);
        const userCourses = await getUserCourses(user.id);
        const isEnrolled = userCourses.some((course: any) => course.course_id === courseId);
        if (isEnrolled) {
          toast({
            title: "Kursus juba ostetud",
            description: "Sul on juba ligipääs sellele kursusele",
          });
          navigate(`/learner/course/${courseId}`);
          if (onRedirect) onRedirect();
        }
      } catch (error) {
        // Optionally handle errors here
      } finally {
        setCheckingEnrollment(false);
      }
    };
    checkEnrollment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, courseId]);
  return checkingEnrollment;
}
